import { render, staticRenderFns } from "./deleteServiceProvide.vue?vue&type=template&id=8adfdf30"
import script from "./deleteServiceProvide.vue?vue&type=script&lang=js"
export * from "./deleteServiceProvide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports